import cloneDeep from 'lodash/cloneDeep';
import actionTypes from '../actions/action-types';

const initialState = {
  items: [],
  itemsCopy: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_INQUIRY_CONTACTS_SUCCESS: {
      return {
        ...state,
        items: cloneDeep(action.items || []),
        itemsCopy: cloneDeep(action.items || []),
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/contact/reducers/inquiry.js